import * as React from 'react';
import { registerDecorator } from '@avensia/excite-contentful/Document';
import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { isSvenssons } from 'webapp/theme';

const headingDecorator = styled(
  createMinLargeViewportDecorator({
    marginBottom: t => t.sharedSpacing.l,
  }),
  {
    margin: {
      bottom: t => t.sharedSpacing.m,
    },
    fontWeight: t => t.fontWeight?.primary,
  },
);

const H1 = styled.h1(isSvenssons && headingDecorator);
const H2 = styled.h2(headingDecorator);
const H3 = styled.h3(headingDecorator);
const H4 = styled.h4(isSvenssons && headingDecorator);
const H5 = styled.h5(isSvenssons && headingDecorator);
const H6 = styled.h6(isSvenssons && headingDecorator);

registerDecorator<Excite.Contentful.Heading1ApiModel>(
  'h1',
  styled(({ children, attributes }) => {
    if (children === undefined) {
      return null;
    }
    if (children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <H1 {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <H1 {...attributes}>{children}</H1>;
  }),
);

registerDecorator<Excite.Contentful.Heading2ApiModel>(
  'h2',
  styled(({ children, attributes }) => {
    if (children === undefined) {
      return null;
    }
    if (children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <H2 {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <H2 {...attributes}>{children}</H2>;
  }),
);

registerDecorator<Excite.Contentful.Heading3ApiModel>(
  'h3',
  styled(({ children, attributes }) => {
    if (children === undefined) {
      return null;
    }
    if (children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <H3 {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <H3 {...attributes}>{children}</H3>;
  }),
);

registerDecorator<Excite.Contentful.Heading4ApiModel>(
  'h4',
  styled(({ children, attributes }) => {
    if (children === undefined) {
      return null;
    }
    if (children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <H4 {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <H4 {...attributes}>{children}</H4>;
  }),
);

registerDecorator<Excite.Contentful.Heading5ApiModel>(
  'h5',
  styled(({ children, attributes }) => {
    if (children === undefined) {
      return null;
    }
    if (children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <H5 {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <H5 {...attributes}>{children}</H5>;
  }),
);

registerDecorator<Excite.Contentful.Heading6ApiModel>(
  'h6',
  styled(({ children, attributes }) => {
    if (children === undefined) {
      return null;
    }
    if (children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <H6 {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <H6 {...attributes}>{children}</H6>;
  }),
);
